module.exports = __webpack_public_path__ + "media/images/favicon-3e1fe00dd996ff4ec661ecb200ea90e3.png";